import { render, staticRenderFns } from "./tabulation-carousel.vue?vue&type=template&id=6f09bd48&scoped=true"
import script from "./tabulation-carousel.vue?vue&type=script&lang=js"
export * from "./tabulation-carousel.vue?vue&type=script&lang=js"
import style0 from "./tabulation-carousel.vue?vue&type=style&index=0&id=6f09bd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f09bd48",
  null
  
)

export default component.exports